module.exports = __webpack_public_path__ + "static/media/picture-(277).78b13579.JPG";